import { toFixedAmount } from "../../../../utils/number-util";

export function NegativeMarker({ amount }: { amount: number }) {
  return amount < 0 ? (
    <span className="text-red-500">{toFixedAmount(Math.abs(amount))}</span>
  ) : (
    <span>{toFixedAmount(amount)}</span>
  );
}
